export async function getTaboolaClickId() {
  if (typeof URL === 'undefined') {
    return {};
  }

  const url = new URL(window.location.href);

  if (url.searchParams.has('taboola_click_id')) {
    return {
      taboola_click_id: url.searchParams.get('taboola_click_id'),
    };
  }

  return {};
}
